import { Typography } from "antd";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import GlobalSettingAPI from "restAPI/GlobalSettingAPI";

const { Link } = Typography;

const CustomRiskDocLink: React.FC = () => {
  const [customRiskScoreDocLink, setCustomRiskScoreDocLink] =
    useState<string>("#");

  useEffect(() => {
    const { promise, cancel } =
      GlobalSettingAPI.getCustomRiskScoreDocLinkConfig();

    promise
      .then((res) => {
        if (!_.isEmpty(res)) {
          setCustomRiskScoreDocLink(res.customRiskScoreDocLink);
        }
      })
      .catch((err) => console.error("Failed to fetch risk doc link:", err));

    return cancel;
  }, []);

  return (
    <Link
      href={customRiskScoreDocLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      documentation
    </Link>
  );
};

export default CustomRiskDocLink;
